import type { ModelAddButtonProps } from "./model-add-button.type";

import { useAuthorization } from "@/modules/authorization";

import ModelAddButton from "./model-add-button.component";

const ModelAddButtonWrapper = (props: ModelAddButtonProps) => {
  const { canCreateModel } = useAuthorization();

  if (!canCreateModel(props.model)) return null;

  return <ModelAddButton {...props} />;
};

export default ModelAddButtonWrapper;
